import React from 'react';
import styled from 'styled-components';
import { GqlImageBanner, GqlImageBannerPlatform, ImageBannerPlatformType } from 'types/graphql';
import { Hyperlink as HyperlinkIcon } from 'src/svg/hyperlink';

import { displayBannerPlatforms } from '../../image-banner-modal/image-banner-modal.helper';
import { LinkContainer } from './image-banner-list-item.styles';

type ImageBannerLinksProps = {
  banner: GqlImageBanner;
  hasMobileApp: boolean;
  showLinkText?: boolean;
};

export function ImageBannerLinks({ banner, hasMobileApp, showLinkText = true }: ImageBannerLinksProps): JSX.Element {
  const { link, platforms } = banner;

  return (
    <PlatformLinks>
      {Object.values(displayBannerPlatforms).map((item) => {
        const platform: GqlImageBannerPlatform = platforms?.find((p) => p?.type === item.value) ?? {
          enabled: true,
          link,
          openInNewTab: true,
          type: item.value,
        };

        if (!platform.enabled) {
          return null;
        }

        if (platform.type === ImageBannerPlatformType.iosMobileApp && !hasMobileApp) {
          return null;
        }

        return (
          <PlatformLinkContainer key={platform.type}>
            <b>{item.label}</b>
            {platform.link ? (
              <a href={platform.link} target='_blank' rel='noreferrer'>
                <HyperlinkIcon />
                {showLinkText ? ' View link' : ''}
              </a>
            ) : (
              <>
                <HyperlinkIcon />
                {showLinkText ? ' No link' : ''}
              </>
            )}
          </PlatformLinkContainer>
        );
      })}
    </PlatformLinks>
  );
}

const PlatformLinks = styled.div`
  display: flex;
  flex-grow: 1;
`;

const PlatformLinkContainer = styled(LinkContainer)`
  border-right: 1px solid #d9d9d9;
  flex-grow: 0;
  font-weight: normal;
  line-height: 1;
  margin-right: 20px;
  padding-right: 20px;

  &:last-child {
    border-right: none;
    padding-right: 0;
    margin-right: 0;
  }

  a {
    align-items: center;
    display: flex;
  }

  a,
  b {
    font-weight: 700;
  }

  b,
  svg {
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
  }

  svg {
    margin-right: 3px;
  }
`;
